module.exports = __webpack_public_path__ + "img/banner-3.5343b64d.png";